<template>
    <div
        v-if="shown"
        class="alert"
        :class="alertClass"
    >
        <div :class="alertIconClass" class="alert-icon">
            <font-awesome-icon :icon="icon" />
        </div>

        <div class="alert-text">{{ body }}</div>

        <div
            v-if="displayCloseButton"
            class="ml-auto mr-0 cursor-pointer"
            @click="hide"
        >
            <font-awesome-icon
                :icon="['fas', 'times']"
                class="close"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            initialBody: {
                type: String,
                default: '',
            },
            displayCloseButton: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                body: '',
                shown: false,
            };
        },
        computed: {
            eventClass() {
                return 'flash_' + this.type;
            },
            alertClass() {
                return 'is-' + this.type;
            },
            alertIconClass() {
                return `bg-${this.type}-light`;
            },
        },
        created() {
            if (this.initialBody.length > 0) {
                this.body = this.initialBody;
                this.show();
            }

            // To avoid duplicates if we have several alerts with initialBody
            // and then trigger another alert using javascript.
            if (this.initialBody.length < 1) {
                EventBus.$on(
                    this.eventClass, (options) => { this.flash(options); },
                );
            }

            if (this.type === 'error') {
                EventBus.$on('clear-errors', () => { this.shown = false; });
            }
        },
        methods: {
            show() {
                this.shown = true;
                window.scrollTo(0, 0);
            },
            flash(options) {
                this.body = options.message;
                this.show();
            },
            hide() {
                this.shown = false;
            },
        },
    };
</script>
